import(/* webpackMode: "eager", webpackExports: ["PlayShell"] */ "/vercel/path0/apps/game/app/games/play-shell.tsx");
